<div class="contents-area" (dragstart)="onDragstartBody($event)">
  <div class="split_two_part">
    <div class="block-column">
      <div class="element-column">
        <div class="column-list">
          <label class="list-input-title">対象</label>
          <div class="list-input-content">
            <!-- 対象から "商品マスタ" を外すためコメントアウト -->
            <!-- <app-radio-label id="rdb_Category" #rdb_Category [subid]="'rdb_Category'"
              [(ngModel)]="this.kymw5400Model.categoryDiv" [name]="'grp_CategoryDiv'" [label]="'商品マスタ'" [value]="'0'"
              (change)="eventchkCategoy_CLICKHandler()" [forcedEnabledMode]="'none'" [tabindex]="0">
            </app-radio-label> -->
            <app-radio-label id="rdb_PlanCategory" #rdb_PlanCategory [subid]="'rdb_PlanCategory'"
              [(ngModel)]="this.kymw5400Model.categoryDiv" [name]="'grp_CategoryDiv'" [label]="'商品企画マスタ'" [value]="'1'"
              autoFocus="true" (change)="eventchkPlanCategoy_CLICKHandler()" [forcedEnabledMode]="'none'" [tabindex]="0">
            </app-radio-label>
            <app-radio-label id="rdb_StockCategory" #rdb_StockCategory [subid]="'rdb_StockCategory'"
              [(ngModel)]="this.kymw5400Model.categoryDiv" [name]="'grp_CategoryDiv'" [label]="'在庫限定'" [value]="'2'"
              (change)="eventchkStockCategoy_CLICKHandler()" [forcedEnabledMode]="'none'" [tabindex]="0">
            </app-radio-label>
          </div>

          <label class="list-input-title">受注コード</label>
          <div class="list-input-content">
            <app-order-code-text-input id="txti_OrderCode" #txti_OrderCode
              [subid]="'txti_OrderCode'" [(ngModel)]="this.kymw5400Model.orderCode" [required]="true"
              [catalogIDField]="lbl_CatalogId" (ngModelChange)="eventOrderCode_CHANGEHandler(null)"
              [forcedEnabledMode]="'none'" [tabindex]="0">
            </app-order-code-text-input>
          </div>

          <label class="list-input-title">配達企画回（翌週）</label>
          <div class="list-input-content">
            <input type="text" class="label-text deliv-catalog" id="lbl_CatalogId" #lbl_CatalogId readonly>
          </div>
        </div>
      </div>

      <div>
        <h1>カテゴリ一覧</h1>
        <div class="element-column">
          <button class="btn-secondary" id="btn_Display" #btn_Display (click)="eventDisplay_CLICKHandler()"
            forcedEnabledMode="true" [tabindex]="0">表示</button>
          <wj-tree-view [style.width.px]="440" [style.height.px]="230" class="card" id="tre_Category" #tre_Category
            [itemsSource]="this.kymw5400Model.categoryInfoList" [displayMemberPath]="'CategoryName'"
            [childItemsPath]="'Category'" (itemClicked)="eventSelect_CLICKHandler()" [expandOnLoad]="false"
            (keydown)="eventKeybordSelect_KEYDOWNHandler($event)" (formatItem)="formatItem(tre_Category, $event)"
            forcedEnabledMode="none" [tabindex]="0">
          </wj-tree-view>
        </div>
      </div>
    </div>

    <div>
      <h1>商品一覧</h1>
      <div class="element-row">
        <button class="btn-secondary" id="btn_Search" #btn_Search [disabled]="true"
          (click)="eventSearchGoods_CLICKHandler()" forcedEnabledMode="" [tabindex]="0">商品検索</button>
        <button class="btn-secondary" style="width:auto;" id="btn_KYMW58" (click)="eventKYMW58_CLICKHandler()" forcedEnabledMode="true"
          [tabindex]="0">EC企画商品別カテゴリ設定一覧表</button>
      </div>

      <div>
        <div class="action-area">
          <app-pager [prevDisabled]="kymw5400Model.prevDisabled" [nextDisabled]="kymw5400Model.nextDisabled"
            [totalNum]="kymw5400Model.totalNum" [startNum]="kymw5400Model.startDispNum"
            [endNum]="kymw5400Model.endDispNum" (prevHandler)="eventPrev_CLICKHandler()"
            (nextHandler)="eventNext_CLICKHandler()">
          </app-pager>
        </div>

        <wj-flex-grid id="dtg_GoodsList"
          #dtg_GoodsList [itemsSource]="this.kymw5400Model.goodsList" [selectionMode]="'ListBox'"
          [headersVisibility]="'Column'" [allowSorting]="false" [isReadOnly]="true" [allowDragging]="'None'"
          (click)="eventDtgPlanGoodsList_HEADERRELEASEHandler($event,dtg_GoodsList)"
          (itemsSourceChanged)="onItemsSourceChangedGoodsList()" forcedEnabledMode="none" [tabindex]="0">
          <wj-flex-grid-column [minWidth]="5" [header]="'媒体'" [binding]="'MediumTypeName'" [width]="150">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'部門'" [binding]="'ClassCodeName'" [width]="140">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'小分類'" [binding]="'SmallClassCodeName'" [width]="220">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'Ｐコード'" [binding]="'Pcode'" [width]="100">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'商品名'" [binding]="'GoodsName'" [width]="330">
          </wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'規格名'" [binding]="'GoodsStandardName'" [width]="194">
          </wj-flex-grid-column>
        </wj-flex-grid>
      </div>
    </div>
  </div>

  <div style="width: 1623px;">
    <h1>カテゴリ商品設定一覧</h1>
    <div>
      <div class="action-area">
        <div class="guide-label">
          <label class="bg_blue">設定を変更</label>
          <label class="bg_pink">設定を解除</label>
        </div>
      </div>

      <wj-flex-grid id="dtg_CategoryGoodsList"
        #dtg_CategoryGoodsList [itemsSource]="this.kymw5400Model.categoryGoodsList" [selectionMode]="'Row'"
        [headersVisibility]="'Column'" [allowDragging]="'None'" [isReadOnly]="true"
        (itemsSourceChanged)="onItemsSourceChangedCategoryGoodsList()" [tabindex]="0">
        <wj-flex-grid-column [minWidth]="5" [header]="'部門'" [binding]="'ClassCodeName'" [width]="140">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'小分類'" [binding]="'SmallClassCodeName'" [width]="220">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'Ｐコード'" [binding]="'PCode'" [width]="100">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'商品名'" [binding]="'GuideGoodsName'" [width]="470">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'規格名'" [binding]="'GuideStandardName'" [width]="200">
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'EC掲載順'" [binding]="'ECShowSeq'" [width]="75">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <input type="text" #txti_ECShowSeq id="txti_ECShowSeq" plessInputTextSub [restrict]="'[.0-9]'" (input)="eventECShowSeq_CHANGEHandler()"
            (focus)="onInputFocus(cell.row.index, cell.col.index)" [tabindex]="0" [maxlength]="3" [(ngModel)]="cell.item.ECShowSeq" [style.width.%]="100"/>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'い'" [binding]="'CoopFlgI'" [width]="50" [align]="'center'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div *ngIf="this.CategoryGoodsListRendererList[cell.item.CoopFlgI]"
              [style.background-color]="this.CategoryGoodsListRendererList[cell.item.CoopFlgI].setStyle"
              class="text-center">
              {{ this.CategoryGoodsListRendererList[cell.item.CoopFlgI].labelText }}
            </div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'と'" [binding]="'CoopFlgTo'" [width]="50" [align]="'center'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div *ngIf="this.CategoryGoodsListRendererList[cell.item.CoopFlgTo]"
              [style.background-color]="this.CategoryGoodsListRendererList[cell.item.CoopFlgTo].setStyle"
              class="text-center">
              {{ this.CategoryGoodsListRendererList[cell.item.CoopFlgTo].labelText }}
            </div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ぐ'" [binding]="'CoopFlgGu'" [width]="50" [align]="'center'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div *ngIf="this.CategoryGoodsListRendererList[cell.item.CoopFlgGu]"
              [style.background-color]="this.CategoryGoodsListRendererList[cell.item.CoopFlgGu].setStyle"
              class="text-center">
              {{ this.CategoryGoodsListRendererList[cell.item.CoopFlgGu].labelText }}
            </div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'ち'" [binding]="'CoopFlgChi'" [width]="50" [align]="'center'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div *ngIf="this.CategoryGoodsListRendererList[cell.item.CoopFlgChi]"
              [style.background-color]="this.CategoryGoodsListRendererList[cell.item.CoopFlgChi].setStyle"
              class="text-center">
              {{ this.CategoryGoodsListRendererList[cell.item.CoopFlgChi].labelText }}
            </div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'さ'" [binding]="'CoopFlgSa'" [width]="50" [align]="'center'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div *ngIf="this.CategoryGoodsListRendererList[cell.item.CoopFlgSa]"
              [style.background-color]="this.CategoryGoodsListRendererList[cell.item.CoopFlgSa].setStyle"
              class="text-center">
              {{ this.CategoryGoodsListRendererList[cell.item.CoopFlgSa].labelText }}
            </div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'とう'" [binding]="'CoopFlgTou'" [width]="50" [align]="'center'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div *ngIf="this.CategoryGoodsListRendererList[cell.item.CoopFlgTou]"
              [style.background-color]="this.CategoryGoodsListRendererList[cell.item.CoopFlgTou].setStyle"
              class="text-center">
              {{ this.CategoryGoodsListRendererList[cell.item.CoopFlgTou].labelText }}
            </div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'な'" [binding]="'CoopFlgNa'" [width]="50" [align]="'center'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div *ngIf="this.CategoryGoodsListRendererList[cell.item.CoopFlgNa]"
              [style.background-color]="this.CategoryGoodsListRendererList[cell.item.CoopFlgNa].setStyle"
              class="text-center">
              {{ this.CategoryGoodsListRendererList[cell.item.CoopFlgNa].labelText }}
            </div>
          </ng-template>
        </wj-flex-grid-column>
        <wj-flex-grid-column [minWidth]="5" [header]="'に'" [binding]="'CoopFlgNi'" [width]="50" [align]="'center'">
          <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
            <div *ngIf="this.CategoryGoodsListRendererList[cell.item.CoopFlgNi]"
              [style.background-color]="this.CategoryGoodsListRendererList[cell.item.CoopFlgNi].setStyle"
              class="text-center">
              {{ this.CategoryGoodsListRendererList[cell.item.CoopFlgNi].labelText }}
            </div>
          </ng-template>
        </wj-flex-grid-column>
      </wj-flex-grid>

      <div class="layout_end" style="padding-right: 18px;">
        <table>
          <tbody>
            <tr>
              <td borderStyle="none">
                <label class="font-weight-bold" [style.width.px]="30" textAlign="center">合計</label>
              </td>
              <td class="frame-solid text-center">
                <label [style.width.px]="47" id="lbl_CoopAllGoodsCount" textAlign="center">{{
                  this.kymw5400Model.coopAllGoodsCount }}</label>
              </td>
              <td class="frame-solid text-center">
                <label [style.width.px]="47" id="lbl_CoopIGoodsCount" textAlign="center">{{
                  this.kymw5400Model.coopIGoodsCount }}</label>
              </td>
              <td class="frame-solid text-center">
                <label [style.width.px]="47" id="lbl_CoopToGoodsCount" textAlign="center">{{
                  this.kymw5400Model.coopToGoodsCount }}</label>
              </td>
              <td class="frame-solid text-center">
                <label [style.width.px]="47" id="lbl_CoopGuGoodsCount" textAlign="center">{{
                  this.kymw5400Model.coopGuGoodsCount }}</label>
              </td>
              <td class="frame-solid text-center">
                <label [style.width.px]="47" id="lbl_CoopChiGoodsCount" textAlign="center">{{
                  this.kymw5400Model.coopChiGoodsCount }}</label>
              </td>
              <td class="frame-solid text-center">
                <label [style.width.px]="47" id="lbl_CoopSaGoodsCount" textAlign="center">{{
                  this.kymw5400Model.coopSaGoodsCount }}</label>
              </td>
              <td class="frame-solid text-center">
                <label [style.width.px]="47" id="lbl_CoopTouGoodsCount" textAlign="center">{{
                  this.kymw5400Model.coopTouGoodsCount }}</label>
              </td>
              <td class="frame-solid text-center">
                <label [style.width.px]="47" id="lbl_CoopNaGoodsCount" textAlign="center">{{
                  this.kymw5400Model.coopNaGoodsCount }}</label>
              </td>
              <td class="frame-solid text-center">
                <label [style.width.px]="47" id="lbl_CoopNiGoodsCount" textAlign="center">{{
                  this.kymw5400Model.coopNiGoodsCount }}</label>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<footer class="footer-buttons">
  <button class="btn-tartiary warning" id="btn_Cancel" #btn_Cancel (click)="eventCancel_CLICKHandler()" forcedEnabledMode=""
    [tabindex]="0">取消</button>
  <button class="btn-primary" id="btn_Update" #btn_Update (click)="eventUpdate_CLICKHandler()" forcedEnabledMode=""
    [tabindex]="0">更新</button>
</footer>